import { Button } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Theme, makeStyles } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FormatListBulletedSharpIcon from "@material-ui/icons/FormatListBulletedSharp";
import { ColDef, EditableCallbackParams } from "ag-grid-community";
import React, { useState } from "react";
import { useProfilesContext } from "../../../context/ProfileContext";
import { Profile } from "../../../models/Profile";

const useStyles = makeStyles((theme: Theme) => ({
	buttons: {},
}));

type Props = {
	setProfileId: (profile: Profile) => void;
	setModalProceduresProfile: (showModal: boolean) => void;
	setModalDeleteProfile: (showModal: boolean) => void;
	showContextMenu: Function;
};

export const useTableData = ({
	setProfileId,
	setModalProceduresProfile,
	setModalDeleteProfile,
	showContextMenu,
}: Props) => {
	const { state } = useProfilesContext();
	const classes = useStyles();

	const rows = state.profiles.map(({ ProfileId, ProfileName }: Profile) => ({
		id: ProfileId,
		ProfileId,
		ProfileName: ProfileName,
	}));
	const columnDefs: ColDef[] = [
		{
			field: "ProfileName",
			headerName: "Profile name",
			minWidth: 170,
			flex: 2,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "Actions",
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
						className={classes.buttons}
					>
						<Grid
							item
							xs={12}
							md={12}
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Button
								size="small"
								style={{ minWidth: 36, padding: 4 }}
								onClick={() => {
									(async () => {
										setProfileId(params?.data as Profile);
										setModalProceduresProfile(true);
									})();
								}}
							>
								<EditIcon color="primary" fontSize="small" />
							</Button>
							<Button
								size="small"
								style={{ minWidth: 36, padding: 4 }}
								onClick={() => {
									(async () => {
										setProfileId(params.data as Profile);
										setModalDeleteProfile(true);
									})();
								}}
							>
								<DeleteIcon color="secondary" fontSize="small" />
							</Button>
							<Button
								size="small"
								style={{ minWidth: 36, padding: 4 }}
								onClick={(e) =>
									showContextMenu(e, params.data, "TableProfiles")
								}
							>
								<FormatListBulletedSharpIcon color="action" fontSize="small" />
							</Button>
						</Grid>
					</Grid>
				);
			},
			headerName: " ",
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			sortable: false,
			flex: 2,
			minWidth: 300,
		},
	];

	return { rows, columnDefs };
};
